<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onInvoiceSearch"
          v-model="filter_search"
          class="input--200"
          type="search"
          placeholder="Search"
          name="search_invoice"
        />
      </app-cells>
      <app-cells><h2 class="title">Bank</h2></app-cells>
      <v-client-table
        :data="table_bank.items"
        :columns="table_bank.columns"
        :options="table_bank.options"
        class="table-default"
        :class="{ 'table-default--loading': table_bank_preloader }"
      >
        <template #h__payer><div class="table-default__left">Payer</div></template>
        <template #h__invoice><div class="table-default__left">Invoice</div></template>
        <template #h__select>
          <label
            v-if="table_bank.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked.length || checked_bank_cc.length }"
          >
            <input
              v-model="checked_all_bank"
              :disabled="!!(checked.length || checked_bank_cc.length)"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table" :class="{ 'checkbox--readonly': checked.length || checked_bank_cc.length }">
            <input
              v-model="checked_bank"
              :disabled="!!(checked.length || checked_bank_cc.length)"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #date_of_payment="{ row }">{{ dateFormat(row.date_of_payment) }}</template>
        <template #invoice="{ row }">
          <a
            :href="`https://story.altezza.travel/changeInvoice/${row.story_id}/`"
            target="_blank"
            class="table-default__link-border"
          >
            {{ row.number }}
          </a>
        </template>
        <template #payer="{ row }">
          <div class="table-default__left">
            {{ row.payer }}
            <template v-if="row.supplier"><br>{{ row.supplier.legal_name }}</template>
          </div>
        </template>
        <template #total_amount="{ row }">{{ amountFormat(row.amount_payable_usd) }} $</template>
        <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }} $</template>
        <template #amount_exempted="{ row }">{{ amountFormat(row.amount_exempted) }} $</template>
        <template #payment_method="{ row }">{{ row.payment_method?.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationBank"
            v-if="pagination_bank.pages > 1"
            v-model="pagination_bank.page"
            :page-count="pagination_bank.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_bank.count" :count="table_bank.items.length" :page="pagination_bank.page" />
      </app-cells>
      <app-cells><h2 class="title">Bank CC</h2></app-cells>
      <v-client-table
        :data="table_bank_cc.items"
        :columns="table_bank_cc.columns"
        :options="table_bank_cc.options"
        class="table-default"
        :class="{ 'table-default--loading': table_bank_cc_preloader }"
      >
        <template #h__payer><div class="table-default__left">Payer</div></template>
        <template #h__invoice><div class="table-default__left">Invoice</div></template>
        <template #h__select>
          <label
            v-if="table_bank_cc.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked.length || checked_bank.length }"
          >
            <input
              v-model="checked_all_bank_cc"
              :disabled="!!(checked.length || checked_bank.length)"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table" :class="{ 'checkbox--readonly': checked.length || checked_bank.length }">
            <input
              v-model="checked_bank_cc"
              :disabled="!!(checked.length || checked_bank.length)"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #date_of_payment="{ row }">{{ dateFormat(row.date_of_payment) }}</template>
        <template #invoice="{ row }">
          <a
            :href="`https://story.altezza.travel/changeInvoice/${row.story_id}/`"
            target="_blank"
            class="table-default__link-border"
          >
            {{ row.number }}
          </a>
        </template>
        <template #payer="{ row }">
          <div class="table-default__left">
            {{ row.payer }}
            <template v-if="row.supplier"><br>{{ row.supplier.legal_name }}</template>
          </div>
        </template>
        <template #total_amount="{ row }">{{ amountFormat(row.amount_payable_usd) }} $</template>
        <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }} $</template>
        <template #amount_exempted="{ row }">{{ amountFormat(row.amount_exempted) }} $</template>
        <template #payment_method="{ row }">{{ row.payment_method?.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationBankCC"
            v-if="pagination_bank_cc.pages > 1"
            v-model="pagination_bank_cc.page"
            :page-count="pagination_bank_cc.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_bank_cc.count" :count="table_bank_cc.items.length" :page="pagination_bank_cc.page" />
      </app-cells>
      <app-cells><h2 class="title">Cash</h2></app-cells>
      <v-client-table
        :data="table_cash.items"
        :columns="table_cash.columns"
        :options="table_cash.options"
        class="table-default"
        :class="{ 'table-default--loading': table_cash_preloader }"
      >
        <template #h__select>
          <label
            v-if="table_cash.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked_bank.length || checked_bank_cc.length }"
          >
            <input
              v-model="checked_all"
              :disabled="!!(checked_bank.length || checked_bank_cc.length)"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table" :class="{ 'checkbox--readonly': checked_bank.length || checked_bank_cc.length }">
            <input
              v-model="checked"
              :disabled="!!(checked_bank.length || checked_bank_cc.length)"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #h__payer><div class="table-default__left">Payer</div></template>
        <template #h__invoice><div class="table-default__left">Invoice</div></template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button
              class="efd-btn"
              :class="{'btn--preload': efd_preload === row.id}"
              v-tooltip="{ content: 'Create EFD', placement: 'top-end', offset: 10 }"
              @click="onCreateEFD(row.id, fetchItemsCash)"
            >
              <img v-if="efd_preload === row.id" src="@/assets/img/preloader.svg" alt="" class="btn__preloader" />
              <img v-else src="@/assets/img/add-big-button-icon.svg" alt="Add">
            </button>
          </div>
        </template>
        <template #date_of_payment="{ row }">{{ dateFormat(row.date_of_payment) }}</template>
        <template #invoice="{ row }">
          <a
            :href="`https://story.altezza.travel/changeInvoice/${row.story_id}/`"
            target="_blank"
            class="table-default__link-border"
          >
            {{ row.number }}
          </a>
        </template>
        <template #payer="{ row }">
          <div class="table-default__left">
            {{ row.payer }}
            <template v-if="row.supplier"><br>{{ row.supplier.legal_name }}</template>
          </div>
        </template>
        <template #total_amount="{ row }">{{ amountFormat(row.amount_payable_usd) }} $</template>
        <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }} $</template>
        <template #amount_exempted="{ row }">{{ amountFormat(row.amount_exempted) }} $</template>
        <template #payment_method="{ row }">{{ row.payment_method?.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationCash"
            v-if="pagination_cash.pages > 1"
            v-model="pagination_cash.page"
            :page-count="pagination_cash.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_cash.count" :count="table_cash.items.length" :page="pagination_cash.page" />
      </app-cells>
      <app-cells><h2 class="title">Wise</h2></app-cells>
      <v-client-table
        :data="table_wise.items"
        :columns="table_wise.columns"
        :options="table_wise.options"
        class="table-default"
        :class="{ 'table-default--loading': table_wise_preloader }"
      >
        <template #h__payer><div class="table-default__left">Payer</div></template>
        <template #h__invoice><div class="table-default__left">Invoice</div></template>
<!--        <template #controls="{ row }">-->
<!--          <div class="table-default__controls">-->
<!--            <button-->
<!--              class="efd-btn"-->
<!--              :class="{'btn&#45;&#45;preload': efd_preload === row.id}"-->
<!--              v-tooltip="{ content: 'Create EFD', placement: 'top-end', offset: 10 }"-->
<!--              @click="onCreateEFD(row.id, fetchItemsWise)"-->
<!--            >-->
<!--              <img v-if="efd_preload === row.id" src="@/assets/img/preloader.svg" alt="" class="btn__preloader" />-->
<!--              <img v-else src="@/assets/img/add-big-button-icon.svg" alt="Add">-->
<!--            </button>-->
<!--          </div>-->
<!--        </template>-->
        <template #date_of_payment="{ row }">{{ dateFormat(row.date_of_payment) }}</template>
        <template #invoice="{ row }">
          <a
            :href="`https://story.altezza.travel/changeInvoice/${row.story_id}/`"
            target="_blank"
            class="table-default__link-border"
          >
            {{ row.number }}
          </a>
        </template>
        <template #payer="{ row }">
          <div class="table-default__left">
            {{ row.payer }}
            <template v-if="row.supplier"><br>{{ row.supplier.legal_name }}</template>
          </div>
        </template>
        <template #total_amount="{ row }">{{ amountFormat(row.amount_payable_usd) }} $</template>
        <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }} $</template>
        <template #amount_exempted="{ row }">{{ amountFormat(row.amount_exempted) }} $</template>
        <template #payment_method="{ row }">{{ row.payment_method?.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationWise"
            v-if="pagination_wise.pages > 1"
            v-model="pagination_wise.page"
            :page-count="pagination_wise.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_wise.count" :count="table_wise.items.length" :page="pagination_wise.page" />
      </app-cells>
      <app-cells><h2 class="title">EFD Issued</h2></app-cells>
      <v-client-table
        :data="table_issued.items"
        :columns="table_issued.columns"
        :options="table_issued.options"
        class="table-default"
        :class="{ 'table-default--loading': table_issued_preloader }"
      >
        <template #h__payer><div class="table-default__left">Payer</div></template>
        <template #h__invoice><div class="table-default__left">Invoice</div></template>
        <template #verification_code="{ row }">
          <button
            @click="onCopyToClipboard(row.efd_receipt.verification_code)"
            class="table-default__copy"
            :class="{'table-default__copy--disabled': !row.efd_receipt.verification_code}"
          >
            {{ row.efd_receipt.verification_code || '-' }}
          </button>
        </template>
        <template #date_of_payment="{ row }">{{ dateFormat(row.date_of_payment) }}</template>
        <template #invoice="{ row }">
          <a
            :href="`https://story.altezza.travel/changeInvoice/${row.story_id}/`"
            target="_blank"
            class="table-default__link-border"
          >
            {{ row.number }}
          </a>
        </template>
        <template #payer="{ row }">
          <div class="table-default__left">
            {{ row.payer }}
            <template v-if="row.supplier"><br>{{ row.supplier.legal_name }}</template>
          </div>
        </template>
        <template #total_amount="{ row }">{{ amountFormat(row.amount_payable_usd) }} $</template>
        <template #amount_vat="{ row }">{{ amountFormat(row.amount_vat) }} $</template>
        <template #amount_exempted="{ row }">{{ amountFormat(row.amount_exempted) }} $</template>
        <template #payment_method="{ row }">{{ row.payment_method?.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationIssued"
            v-if="pagination_issued.pages > 1"
            v-model="pagination_issued.page"
            :page-count="pagination_issued.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_issued.count" :count="table_issued.items.length" :page="pagination_issued.page" />
      </app-cells>
      <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
        <div class="flying-block__text">
          Selected payments:
          <template v-if="checked.length"><span>{{ checked.length }}</span> ({{ checkedSum ? `${amountFormat(checkedSum)}$` : '' }})</template>
          <template v-if="checked_bank.length"><span>{{ checked_bank.length }}</span> ({{ checkedBankSum ? `${amountFormat(checkedBankSum)}$` : '' }})</template>
          <template v-if="checked_bank_cc.length"><span>{{ checked_bank_cc.length }}</span> ({{ checkedBankCCSum ? `${amountFormat(checkedBankCCSum)}$` : '' }})</template>
        </div>
        <app-button @click.native="onMakeIssue" ref="efd_cash">Issue EFD</app-button>
      </div>
    </template>
  </div>
</template>

<script>
import { getFinanceInvoiceList, postFinanceInvoiceEFD, postFinanceInvoicesEFD } from '@/http'
import { format, parseISO } from 'date-fns'
import debounce from 'lodash/debounce'

export default {
  name: 'FinanceEFDInvoices',
  data() {
    return {
      page_loaded: false,
      table_bank_preloader: false,
      table_bank_cc_preloader: false,
      table_cash_preloader: false,
      table_wise_preloader: false,
      table_issued_preloader: false,
      filter_search: '',
      checked_all: false,
      checked_all_bank: false,
      checked_all_bank_cc: false,
      checked: [],
      checked_bank: [],
      checked_bank_cc: [],
      is_show_flying_block: false,
      table_bank: {
        items: [],
        columns: [
          'select',
          'date_of_payment',
          'payment_method',
          'invoice',
          'payer',
          'total_amount',
          'amount_vat',
          'amount_exempted',
        ],
        options: {
          headings: {
            'select': '',
            'date_of_payment': 'Payment date',
            'payment_method': 'Payment method',
            'invoice': 'Invoice',
            'payer': 'Payer',
            'total_amount': 'Total',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bank: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_bank_cc: {
        items: [],
        columns: [
          'select',
          'date_of_payment',
          'payment_method',
          'invoice',
          'payer',
          'total_amount',
          'amount_vat',
          'amount_exempted',
        ],
        options: {
          headings: {
            'select': '',
            'date_of_payment': 'Payment date',
            'payment_method': 'Payment method',
            'invoice': 'Invoice',
            'payer': 'Payer',
            'total_amount': 'Total',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bank_cc: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_cash: {
        items: [],
        columns: [
          'select',
          'date_of_payment',
          'payment_method',
          'invoice',
          'payer',
          'total_amount',
          'amount_vat',
          'amount_exempted',
        ],
        options: {
          headings: {
            'select': '',
            'date_of_payment': 'Payment date',
            'payment_method': 'Payment method',
            'invoice': 'Invoice',
            'payer': 'Payer',
            'total_amount': 'Total',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_cash: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_wise: {
        items: [],
        columns: [
          // 'controls',
          'date_of_payment',
          'payment_method',
          'invoice',
          'payer',
          'total_amount',
          'amount_vat',
          'amount_exempted',
        ],
        options: {
          headings: {
            // 'controls': 'EFD',
            'date_of_payment': 'Payment date',
            'payment_method': 'Payment method',
            'invoice': 'Invoice',
            'payer': 'Payer',
            'total_amount': 'Total',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_wise: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_issued: {
        items: [],
        columns: [
          'verification_code',
          'date_of_payment',
          'payment_method',
          'invoice',
          'payer',
          'total_amount',
          'amount_vat',
          'amount_exempted',
        ],
        options: {
          headings: {
            'verification_code': 'Verification code',
            'date_of_payment': 'Payment date',
            'payment_method': 'Payment method',
            'invoice': 'Invoice',
            'payer': 'Payer',
            'total_amount': 'Total',
            'amount_vat': 'VAT',
            'amount_exempted': 'Exempted',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_issued: {
        pages: 1,
        page: 1,
        count: 1,
      },
      efd_preload: null,
      current_page_bank: 1,
      current_page_bank_cc: 1,
      current_page: 1,
    }
  },
  computed: {
    checkedSum() {
      if (this.checked.length) {
        return this.checked
          .map(item => parseFloat(item.amount_payable_usd))
          .reduce((a, b) => {
            return a + b
          }, 0)
      } else {
        return ''
      }
    },
    checkedBankSum() {
      if (this.checked_bank.length) {
        return this.checked_bank
          .map(item => parseFloat(item.amount_payable_usd))
          .reduce((a, b) => {
            return a + b
          }, 0)
      } else {
        return ''
      }
    },
    checkedBankCCSum() {
      if (this.checked_bank_cc.length) {
        return this.checked_bank_cc
          .map(item => parseFloat(item.amount_payable_usd))
          .reduce((a, b) => {
            return a + b
          }, 0)
      } else {
        return ''
      }
    }
  },
  watch: {
    checked_all(value) {
      if (this.current_page !== this.pagination_cash.page) return
      if (value) {
        this.table_cash.items.forEach(item => {
          if (!this.checked.map(item => item.id).includes(item.id)) this.checked.push(item)
        })
      } else {
        this.checked = this.checked.filter(item => !this.table_cash.items.map(subitem => subitem.id).includes(item.id))
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
    checked_all_bank(value) {
      if (this.current_page_bank !== this.pagination_bank.page) return
      if (value) {
        this.table_bank.items.forEach(item => {
          if (!this.checked_bank.map(item => item.id).includes(item.id)) this.checked_bank.push(item)
        })
      } else {
        this.checked_bank = this.checked_bank.filter(item => !this.table_bank.items.map(subitem => subitem.id).includes(item.id))
      }
    },
    checked_bank(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_bank.length) this.checked_all_bank = false
    },
    checked_all_bank_cc(value) {
      if (this.current_page_bank_cc !== this.pagination_bank_cc.page) return
      if (value) {
        this.table_bank_cc.items.forEach(item => {
          if (!this.checked_bank_cc.map(item => item.id).includes(item.id)) this.checked_bank_cc.push(item)
        })
      } else {
        this.checked_bank_cc = this.checked_bank_cc.filter(item => !this.table_bank_cc.items.map(subitem => subitem.id).includes(item.id))
      }
    },
    checked_bank_cc(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_bank_cc.length) this.checked_all_bank_cc = false
    },
  },
  created() {
    Promise.all([
      this.fetchItemsBank(),
      this.fetchItemsBankCC(),
      this.fetchItemsCash(),
      this.fetchItemsWise(),
      this.fetchItemsIssued(),
    ])
      .then(() => {
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsBank() {
      this.table_bank_preloader = true
      const response = await getFinanceInvoiceList({
        page: this.pagination_bank.page,
        page_size: 20,
        search: this.filter_search,
        efd_receipt: false,
        vfd: 'bank',
        ordering: '-date_of_payment,-amount_payable_usd,-id'
      })
      this.table_bank.items = response.data.results
      this.pagination_bank.pages = response.data.pages
      this.pagination_bank.count = response.data.count
      this.table_bank_preloader = false
    },
    async fetchItemsBankCC() {
      this.table_bank_cc_preloader = true
      try {
        const response = await getFinanceInvoiceList({
          page: this.pagination_bank_cc.page,
          page_size: 20,
          search: this.filter_search,
          efd_receipt: false,
          vfd: 'bank_cc',
          ordering: '-date_of_payment,-amount_payable_usd,-id'
        })
        this.table_bank_cc.items = response.data.results
        this.pagination_bank_cc.pages = response.data.pages
        this.pagination_bank_cc.count = response.data.count
      } finally {
        this.table_bank_cc_preloader = false
      }
    },
    async fetchItemsCash() {
      this.table_cash_preloader = true
      const response = await getFinanceInvoiceList({
        page: this.pagination_cash.page,
        page_size: 20,
        search: this.filter_search,
        efd_receipt: false,
        vfd: 'cash',
        ordering: '-date_of_payment,-amount_payable_usd,-id'
      })
      this.table_cash.items = response.data.results
      this.pagination_cash.pages = response.data.pages
      this.pagination_cash.count = response.data.count
      this.table_cash_preloader = false
    },
    async fetchItemsWise() {
      this.table_wise_preloader = true
      const response = await getFinanceInvoiceList({
        page: this.pagination_wise.page,
        page_size: 20,
        search: this.filter_search,
        efd_receipt: false,
        vfd: 'wise',
        ordering: '-date_of_payment,-amount_payable_usd,-id'
      })
      this.table_wise.items = response.data.results
      this.pagination_wise.pages = response.data.pages
      this.pagination_wise.count = response.data.count
      this.table_wise_preloader = false
    },
    async fetchItemsIssued() {
      this.table_issued_preloader = true
      const response = await getFinanceInvoiceList({
        page: this.pagination_issued.page,
        page_size: 20,
        search: this.filter_search,
        efd_receipt: true,
        ordering: '-date_of_payment,-amount_payable_usd,-id'
      })
      this.table_issued.items = response.data.results
      this.pagination_issued.pages = response.data.pages
      this.pagination_issued.count = response.data.count
      this.table_issued_preloader = false
    },
    onMakeIssue() {
      const selected = [this.checked, this.checked_bank, this.checked_bank_cc].filter(items => items.length)
      if (selected.length !== 1 || this.$refs.efd_cash.preload) return
      this.$refs.efd_cash.preload = true
      return postFinanceInvoicesEFD({ invoices: selected[0].map(item => item.id) })
        .then(() => {
          this.fetchItemsCash()
          this.fetchItemsBank()
          this.fetchItemsBankCC()
          this.fetchItemsIssued()
          this.is_show_flying_block = false
          this.checked = []
          this.checked_bank = []
          this.checked_bank_cc = []
          this.$refs.efd_cash.preload = false
        })
        .catch(() => { this.$refs.efd_cash.preload = false })
    },
    onCreateEFD(id, table_method) {
      this.efd_preload = id
      postFinanceInvoiceEFD(id)
        .then(() => {
          this.efd_preload = null
          table_method()
          this.$notify({
            type: 'success',
            title: 'EFD created',
          })
        })
        .catch(() => { this.efd_preload = null })
    },
    async onClickPaginationBank(page) {
      this.pagination_bank.page = page
      await this.fetchItemsBank()
      this.checked_all_bank = this.checked_bank.some(item => this.table_bank.items.map(subitem => subitem.id).includes(item.id))
      this.$nextTick(() => { this.current_page_bank = page })
    },
    async onClickPaginationBankCC(page) {
      this.current_page_bank_cc = null
      this.pagination_bank_cc.page = page
      try {
        await this.fetchItemsBankCC()
        this.checked_all_bank_cc = this.checked_bank_cc.some(item => this.table_bank_cc.items.map(subitem => subitem.id).includes(item.id))
      } finally {
        this.$nextTick(() => { this.current_page_bank_cc = page })
      }
    },
    async onClickPaginationCash(page) {
      this.pagination_cash.page = page
      await this.fetchItemsCash()
      this.checked_all = this.checked.some(item => this.table_cash.items.map(subitem => subitem.id).includes(item.id))
      this.$nextTick(() => { this.current_page = page })
    },
    onClickPaginationWise(page) {
      this.pagination_wise.page = page
      this.fetchItemsWise()
    },
    onClickPaginationIssued(page) {
      this.pagination_issued.page = page
      this.fetchItemsIssued()
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onInvoiceSearch() {
      this.searchInvoice(this)
    },
    searchInvoice: debounce(vm => {
      vm.pagination_bank.page = 1
      vm.pagination_cash.page = 1
      vm.pagination_wise.page = 1
      vm.fetchItemsBank()
      vm.onClickPaginationBankCC(1)
      vm.fetchItemsCash()
      vm.fetchItemsWise()
    }, 350),
  }
}
</script>

<style lang="sass">
.efd-btn
  position: relative
  background-color: $color-theme
  width: 25px
  height: 25px
</style>
